import {type QueryClient, QueryClientProvider} from '@tanstack/react-query'
import {BlockContextProvider, HydrationProvider} from 'quickstart/hooks'
import type {BlockContext} from 'quickstart/types'
import type * as React from 'react'
import {logger} from 'tizra'
import {ThemeProvider} from './ThemeBlock/branding'

const log = logger('blocks/ComponentWrapper')

export interface ComponentWrapperProps {
  context: BlockContext
  hydrate?: boolean
  queryClient: QueryClient
  children?: React.ReactNode
}

/**
 * Component wrapper that is the inner portion of BlockWrapper. This is factored
 * out of BlockWrapper so it can be used by our implementation of custom
 * elements in markdown.
 */
export const ComponentWrapper = ({
  context,
  hydrate = false,
  queryClient,
  children,
}: ComponentWrapperProps) => (
  <QueryClientProvider client={queryClient}>
    <HydrationProvider hydrate={hydrate}>
      <ThemeProvider context={context}>
        <BlockContextProvider context={context}>
          {children}
        </BlockContextProvider>
      </ThemeProvider>
    </HydrationProvider>
  </QueryClientProvider>
)
